export default "__VITE_ASSET__DiNWVTGm__"